module.exports = __webpack_public_path__ + "static/img/39.a689755f.jpeg";